import React, {Component} from "react"
import configs from '../../../configs.json'
import ApiService from "../../services/api"
const apiservice = new ApiService()

class Contact extends Component {
    constructor(props) {
        super(props)
        this.state = {
            name      : "",
            email     : "",
            subject   : "",
            message   : "",
            ...this.computeColors(props.colored, props.dark)
        }
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    /*handleSubmit(event) {
        event.preventDefault()
        const data = new FormData()

        data.append("username", this.state.username)
        data.append("password", this.state.password)
    }*/

    computeColors(colored, dark) {
        if (colored && dark) {
            return { colored, dark, backgroundColor: configs.colors.primary, text: configs.colors.light, color: configs.colors.dark }
        }
        if (!colored && !dark) {
            return { colored, dark, color: configs.colors.primary, text: configs.colors.dark, backgroundColor: configs.colors.light }
        }
        if (!colored && dark) {
            return { colored, dark, color: configs.colors.primary, text: configs.colors.light, backgroundColor: configs.colors.dark }
        }
        return { colored, dark, backgroundColor: configs.colors.primary, text: configs.colors.dark, color: configs.colors.light }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.colored !== this.props.colored || prevProps.dark !== this.props.dark) {
            this.setState(this.computeColors(this.props.colored, this.props.dark))
        }
    }

    handleSubmit(event) {
        event.preventDefault()

        const data = {
            'email': this.state.email,
            'name':  this.state.name,
            'subject': this.state.subject,
            'message': this.state.message
        }

        apiservice.contact(data).then(() => {
            alert('Sua mensagem foi enviada com sucesso!')
        }).catch((error) => {
            console.log(error)
            alert('Algo deu errado.')
        })

    }

    render() {
        return(
            <div className="container center" style={{backgroundColor: this.state.backgroundColor }} id='contact'>
                <div className="card center-align" style={{backgroundColor: configs.colors.primary}}>
                    <div className="card-title" style={{borderBottom: '1px solid ' + configs.colors.secondary}}>
                        <h3>Contato</h3>
                    </div>
                    <form method="POST" encType="multipart/form-data" onSubmit={this.handleSubmit}>
                        <div className="card-content white-text">
                            <div className="center">
                                <div className="row">
                                    <div className="col s6">
                                        <input id="input_text" type="text" placeholder="Nome" onChange={(e) => {this.setState({name: e.target.value})}} style={{boxShadow: '1px 1px 1px 1px ' + configs.colors.secondary}}/>
                                    </div>
                                    <div className="col s6">
                                        <input id="input_text" type="text" placeholder="Assunto" onChange={(e) => {this.setState({subject: e.target.value})}} style={{boxShadow: '1px 1px 1px 1px ' + configs.colors.secondary}}/>
                                    </div>
                                </div>
                            </div>
                            <div className="center">
                                <div className="row">
                                    <div className="col s12">
                                        <input id="input_text" type="text" placeholder="Email" onChange={(e) => {this.setState({email: e.target.value})}} style={{boxShadow: '1px 1px 1px 1px ' + configs.colors.secondary}}/>
                                    </div>
                                </div>
                            </div>
                            <div className="center">
                                <div className="row">
                                    <div className="col s12">
                                        <input id="input_text" type="text" placeholder="Mensagem" onChange={(e) => {this.setState({message: e.target.value})}} style={{boxShadow: '1px 1px 1px 1px ' + configs.colors.secondary}}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-action" style={{borderTop: '1px solid ' + configs.colors.secondary}}>
                            <button type='submit' className="btn waves-effect waves-light hoverable" style={{backgroundColor: configs.colors.secondary}}>Enviar<i className="material-icons right">send</i></button>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

export default Contact